import { render, staticRenderFns } from "./SidebarRight.vue?vue&type=template&id=448793f4"
import script from "./SidebarRight.vue?vue&type=script&lang=js"
export * from "./SidebarRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports